import enJson from "@/app/locales/english.json";
import chJson from "@/app/locales/chinese.json";
import { menuTabSet } from "./constant/menuTabSet";
import { pageSet } from "./constant/pageSet";

export const getAssetPrefix = () => process.env.NEXT_PUBLIC_WITH_PREFIX === 'Y' ? '/simulcast/informationAsset' : '';

const t = (language: string, key: string, defaultValue?: string) => (language === "en-us" ? enJson as any : chJson as any)[key] || defaultValue || key

export const getMetaSitename= () => "HKJC";

export const getMetaTitle= (language: string, pagename: string) => {
  let title = t(language, 'tab_title_Default');
  switch (pagename) {
    case menuTabSet.RACE_CARD:
      title = t(language, 'tab_title_RaceCard');
      break;
    case menuTabSet.RESULTS:
      title = t(language, 'tab_title_Results');
      break; 
    case menuTabSet.CHANGES:
      title = t(language, 'tab_title_Changes');
      break;
    case menuTabSet.GENERAL_INFORMATION:
      title = t(language, 'tab_title_GeneralInformation');
      break;
    case pageSet.SIMULCAST_FIXTURE:
      title = t(language, 'tab_title_FixturesListView');
      break;
    case pageSet.HORSE_PROFILE:
    case pageSet.SIMULCAST_CALENDAR:
    case pageSet.CARNIVAL:
      break;
    case pageSet.SHAREVIEW:
      title = t(language, 'tab_title_ShareView');
      break;
  }
  return title;
};

export const getMetaKeywords = (language: string, pagename: string) => {
  let description = '';
  switch (pagename) {
    case menuTabSet.RACE_SUMMARY:
      description = t(language, 'tab_meta_description_MeetingSummary');
      break;
    case menuTabSet.ENTRIES:
      description = t(language, 'tab_meta_description_Entries');
      break;
    case menuTabSet.RACE_CARD:
      description = t(language, 'tab_meta_description_RaceCard');
      break;
    case menuTabSet.REFERENCE_ODDS:
      description = t(language, 'tab_meta_description_ReferenceOdds');
      break;
    case menuTabSet.JOCKEYS_RIDES_FOR_THE_DAY:
      description = t(language, 'tab_meta_description_JockeysRidesForTheDay');
      break;
    case menuTabSet.TRAINERS_ENTRIES_FOR_THE_DAY:
      description = t(language, 'tab_meta_description_TrainersEntriesForTheDay');
      break;
    case menuTabSet.JOCKEY_TRAINER_RANKING:
      description = t(language, 'tab_meta_description_JockeyTrainerRanking');
      break;
    case menuTabSet.CHANGES:
      description = t(language, 'tab_meta_description_Changes');
      break;
    case menuTabSet.GENERAL_INFORMATION:
      description = t(language, 'tab_meta_description_GeneralInformation');
      break;
    case menuTabSet.RACING_STATISTICS:
      description = t(language, 'tab_meta_description_RacingStatistics');
      break;
    case menuTabSet.FORM_COMMENT:
      description = t(language, 'tab_meta_description_FormComment');
      break;
    case menuTabSet.TIPSTERS_SELECTION:
      description = t(language, 'tab_meta_description_TipstersSelection');
      break;
    case menuTabSet.EXPERT_COLUMN:
      description = t(language, 'tab_meta_description_ExpertColumn');
      break;
    case menuTabSet.TRACK_ANALYSIS:
      description = t(language, 'tab_meta_description_TrackAnalysis');
      break;
    case menuTabSet.RESULTS:
      description = t(language, 'tab_meta_description_Results');
      break;
    case menuTabSet.NEWS:
      description = t(language, 'tab_meta_description_News');
      break;    
    case pageSet.HORSE_PROFILE:
      description = t(language, 'tab_meta_description_HorseInfo');
      break;
    case pageSet.SIMULCAST_CALENDAR:
      description = t(language, 'tab_meta_description_FixturesCalendarView');
      break;
    case pageSet.SIMULCAST_FIXTURE:
      description = t(language, 'tab_meta_description_FixturesListView');
      break;
    case pageSet.CARNIVAL:
      description = t(language, 'tab_meta_description_OverseasRacingCarnivals');
      break;
  }
  return description;
};

export const getMetaImage = (language: string, pagename: string) => {
  let description = '';
  switch (pagename) {
    case menuTabSet.RACE_SUMMARY:
    case menuTabSet.ENTRIES:
    case menuTabSet.RACE_CARD:
    case menuTabSet.REFERENCE_ODDS:
    case menuTabSet.JOCKEYS_RIDES_FOR_THE_DAY:
    case menuTabSet.TRAINERS_ENTRIES_FOR_THE_DAY:
    case menuTabSet.JOCKEY_TRAINER_RANKING:
    case menuTabSet.CHANGES:
    case menuTabSet.GENERAL_INFORMATION:
    case menuTabSet.RACING_STATISTICS:
    case menuTabSet.FORM_COMMENT:
    case menuTabSet.TIPSTERS_SELECTION:
    case menuTabSet.EXPERT_COLUMN:
    case menuTabSet.TRACK_ANALYSIS:
    case menuTabSet.RESULTS:
    case menuTabSet.NEWS:
    case pageSet.HORSE_PROFILE:
    case pageSet.SIMULCAST_CALENDAR:
    case pageSet.SIMULCAST_FIXTURE:
    case pageSet.CARNIVAL:
    case pageSet.SHAREVIEW:
      description = language === "en-us" ? "https://racing.hkjc.com/racing/common/english/images/logo_hkjc.png" : "https://racing.hkjc.com/racing/common/chinese/images/logo_hkjc.png";
      break;
  }
  return description;
};

export const getMetaIcon = (assetPrefix: string) => {
  return [{ rel: "icon", url: `${assetPrefix}/favicon.ico` }, { rel: "apple-touch-icon", url: `${assetPrefix}/favicon.ico` }]
};